















import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import { InjectReactive } from 'vue-property-decorator'
import {
  CampaignItemPaymentCollectionWithModel
} from '@/modules/campaign-item-payment/models/campaign-item-payment-collection.model'
import AdminCampaignItemPaymentStatus
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentStatusView.vue'
import CampaignItemPaymentTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentTypeView.vue'
import CampaignItemPaymentItemTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentItemTypeView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import AdminCampaignItemPaymentActions
  from '@/modules/campaign-item-payment/components/admin/table/AdminCampaignItemPaymentActions.vue'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'
import CampaignItemLink from '@/modules/shared/components/shared/CampaignItemLink.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminCampaignItemPaymentTableRow extends mixins<TesTableRow>(TesTableRow) {
  @InjectReactive()
  campaignItemPaymentWith: CampaignItemPaymentCollectionWithModel

  constructor(
    private readonly contentItemRoute: AdminContentItemRoutes
  ) {
    super()
  }

  columnComponents = {
    item_id: {
      component: CampaignItemLink,
      handler: (value, row, withData) => ({ item_id: row.item_id, item_type: row.item_type })
    },
    item_type: {
      component: CampaignItemPaymentItemTypeView,
      handler: (value, row, withData) => ({ type: row.item_type, types: withData.payment_item_types })
    },
    amount: {
      component: PriceView,
      handler: (value) => ({ price: value })
    },
    status: {
      component: AdminCampaignItemPaymentStatus,
      handler: (value, row, withData) => ({ status: value, statusesInPersian: withData.statuses }) //withData.statuses : campaignItemPaymentStatuses
    },
    payment_type: {
      component: CampaignItemPaymentTypeView,
      handler: (value, row, withData) => ({ type: row.payment_type, types: withData.payment_types })
    },
    created_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    actions: {
      component: AdminCampaignItemPaymentActions,
      handler: (value, row, withData) => ({ payment: row, withData: withData })
    }
    // author: {
    //   component: AdminUserInfoButton,
    //   handler: value => ({ asText: true, basicUser: value })
    // },
    // description: {
    //   component: TextEllipsis,
    //   handler: value => ({ text: value })
    // }
  }

  showUrl(item) {
      return this.contentItemRoute.show(item.item_id)
  }
}
